import React from 'react';
import { Link } from 'gatsby';
import { NavigationLinkStoryblok, NavigationSubLinkStoryblok } from '../../_shared/interfaces/storyblok';
import { getMultilinkURL } from '../helpers/helpers';

export const getLinkFragment = (
    navEntry: NavigationLinkStoryblok | NavigationSubLinkStoryblok,
    activeClass?: string,
): React.ReactFragment => {
    const url = getMultilinkURL(navEntry.link) || '';

    if (url.startsWith('http')) {
        return (
            <a id={'link-' + navEntry._uid} href={url} target="_blank" role="menuitem" rel="noopener noreferrer">
                {navEntry.text}
            </a>
        );
    } else {
        return (
            <Link id={'link-' + navEntry._uid} to={url} role="menuitem" activeClassName={activeClass}>
                {navEntry.text}
            </Link>
        );
    }
};
